import api from "@/lib/api";

// Fire-and-forget funnel event to the backend analytics foundation.
export function trackFunnel(event, metadata) {
  try {
    api.post("/public/events", { event, metadata: metadata || {} }).catch(() => {});
  } catch {
    /* noop */
  }
}
